import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[500px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20theater%20atmosphere%20with%20dramatic%20warm%20red%20and%20amber%20lighting%2C%20abstract%20curved%20film%20strips%20floating%20in%20space%2C%20lens%20flare%20effects%2C%20dark%20background%20with%20warm%20glow%2C%20creative%20artistic%20composition%2C%20cinematic%20mood%2C%20professional%20photography%20style%2C%20rich%20texture&width=1920&height=900&seq=hero-bg-91video&orientation=landscape"
        alt="91视频 - 海量视频免费在线观看"
        title="91视频网站"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading mb-4 tracking-tight">
          海量视频，<span className="text-primary-400">免费在线观看</span>
        </h1>
        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-8 leading-relaxed">
          高清流畅不卡顿，电影电视剧综艺动漫每日更新。<br className="hidden sm:block" />
          500,000+ 视频内容库，总有一部你想看的。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/dianying"
            className="px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-movie-2-line mr-2"></i>
            开始观影
          </Link>
          <Link
            to="/category/zongyi"
            className="px-8 py-3 rounded-lg bg-background-50/15 backdrop-blur-sm text-background-50 font-semibold text-sm hover:bg-background-50/25 transition-colors border border-background-50/20 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-emotion-laugh-line mr-2"></i>
            热门综艺
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">50万+</p>
            <p className="text-xs md:text-sm text-background-300 mt-1">视频总量</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">2000万+</p>
            <p className="text-xs md:text-sm text-background-300 mt-1">日活用户</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50 font-heading">30+</p>
            <p className="text-xs md:text-sm text-background-300 mt-1">内容分类</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/70 text-2xl"></i>
      </div>
    </section>
  );
}